import React, { useContext, useState } from "react";
import { Container, Nav, Navbar, Button } from "react-bootstrap";
import { CartContext } from "../pages/CartContext";
import { useNavigate, useLocation } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import ConfirmationModal from "./ConfirmationModal";

const Header = () => {
  const { orderMode, setOrderMode, userDetails } = useContext(CartContext);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getOrderTypeLabel = (mode) => {
    switch (mode) {
      case 0:
        return "Table";
      case 1:
        return "Walking Customer";
      case 3:
        return "Home Delivery";
      default:
        return "";
    }
  };

  const handleConfirmChange = () => {
    const currentMode = orderMode;
    setOrderMode(null);
    setShowConfirm(false);
    navigate("/", { state: { lastMode: currentMode }, replace: true });
  };

  const handleChange = () => {
    setShowConfirm(true);
  };

  if (orderMode === null) return null;

  return (
    <>
      <ConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleConfirmChange}
        title="Change Order Type?"
        message="Are you sure you want to change your order type or details?"
        confirmText="Yes, Change"
        cancelText="No, Keep"
        confirmVariant="danger"
      />
      <Navbar bg="white" expand="lg" className="shadow-sm sticky-top py-2">
        <Container fluid className="d-flex justify-content-between align-items-center">
          {/* Customer (Left) */}
          <Nav className="me-auto align-items-center">
            <div className="d-flex align-items-center bg-light px-3 py-1 rounded-pill">
              <FaUser className="text-primary me-2 shadow-sm" style={{ fontSize: "14px" }} />
              <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
                {userDetails?.name || "Customer"}
              </span>
            </div>
          </Nav>

          {/* Order Type (Right) */}
          <Nav className="ms-auto align-items-center">
            <div className="d-flex align-items-center bg-light px-3 py-1 rounded-pill shadow-sm">
              <span className="me-2 text-muted" style={{ fontSize: "14px" }}>
                Order Type: <strong className="text-primary">
                  {getOrderTypeLabel(orderMode)} 
                  {orderMode === 0 && userDetails?.tableNo && ` (${userDetails.tableNo})`}
                </strong>
              </span>

              <Button
                variant="link"
                className="p-0 text-danger fw-bold ms-2"
                style={{ fontSize: "13px", textDecoration: "none" }}
                onClick={handleChange}
              >
                Change
              </Button>
            </div>
          </Nav>
        </Container>
      </Navbar>


    </>
  );
};

export default Header;
